import ReactModel from './ReactModel';
import type {FixedOrPercent} from './InvoiceItemTemplate'

/**
 * Represents a new Invoice Item being added.
 */
export default class InvoiceItem extends ReactModel<InvoiceItemData> {
    constructor(data: Partial<InvoiceItemData> = {}) {
        super({
            amount: 0,
            appliesToIIIds: [], // Invoice Item IDs
            appliesToIIKeys: [], // React keys,
            default: false,
            name: '',
            type: null, // "FIXED" or "PERCENT"
            quantity: data.type === 'PERCENT' ? null : 1,
            feeId: null,
            percentOfBase: false,
            appliesToFeeIds: [],
            ...data,
        });
    }
}

export interface InvoiceItemData {
    amount: number
    appliesToIIIds: StringNum[]
    appliesToIIKeys: string[]
    default: boolean
    name: string
    type: FixedOrPercent|null
    quantity: number|null
    feeId: StringNum|null
    percentOfBase: boolean
    appliesToFeeIds: number[]
}

export interface InvoiceItemModel extends InvoiceItemData {
    id: null|string|number
    key: string
}
